module.exports = __webpack_public_path__ + "img/生活资讯.75cb8a85.png";